const plinkurl = process.env.REACT_APP_SETTING_PAYLINK_URL;

export const formatPaylinkUrl = (paylink: string | undefined) => {
    return paylink ? plinkurl + '/link' + paylink.split('bopp.link')[1] : '';
}